// 일정(Event)
//
// store/index.js 가 이 조각들을 펼쳐 하나의 루트 스토어로 합친다.
// Vuex 의 modules 옵션이 아니라 "조각"인 이유: Vuex 는 namespaced 여부와 무관하게
// 모듈 state 를 모듈 이름 아래에 중첩시킨다. 진짜 모듈로 바꾸면 store.state.tasks 가
// store.state.tasks.tasks 가 되어 소비자 40곳을 전부 고쳐야 한다.
// 조각 합성은 동작이 100% 동일하면서 파일만 나눈다.
//
// **이 조각에는 state 가 없다.**
// 예전에는 events 배열을 들고 있었지만, 캘린더가 통합 아젠다(store/modules/agenda.js)
// 로 옮겨간 뒤로 아무도 읽지 않는 **쓰기 전용** 배열이 됐다 —
// 일정을 만들 때마다 push 되고 갱신될 뿐 화면에는 한 번도 쓰이지 않았다.
// 여기 남는 건 서버 호출 래퍼 3개뿐이고, 화면 갱신은 호출부가 아젠다를
// invalidate 하는 방식으로 처리한다.

import http from '@/utils/http'

export const actions = {
  async createEvent({ commit }, eventData) {
    try {
      const response = await http.post(`/api/events`, eventData)
      // 반복 일정이면 여러 건이 한 번에 생성된다
      if (response.data.events && response.data.count) {
        return { events: response.data.events, count: response.data.count }
      }
      return response.data.event
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || '일정 생성에 실패했습니다.')
      throw error
    }
  },

  /**
   * @param {{ id: number, eventData: object, scope?: 'this'|'thisAndFuture'|'all' }} payload
   *   scope 는 반복 시리즈 수정 범위. 생략하면 'this'(해당 건만, 시리즈에서 분리).
   */
  async updateEvent({ commit }, { id, eventData, scope }) {
    try {
      const response = await http.put(`/api/events/${id}`, eventData, {
        params: scope ? { scope } : undefined
      })
      // 봉투를 통째로 돌려준다. 범위 수정일 때 서버가 실어주는 updated 건수가
      // event 만 꺼내면 유실되어 '3개의 일정이 수정되었습니다' 를 만들 수 없다.
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || '일정 수정에 실패했습니다.')
      throw error
    }
  },

  /**
   * @param {number|{ id: number, scope?: 'this'|'thisAndFuture'|'all' }} payload
   *   숫자를 그대로 넘기던 기존 호출부와 호환된다.
   */
  async deleteEvent({ commit }, payload) {
    const { id, scope } = typeof payload === 'object' ? payload : { id: payload }
    try {
      const response = await http.delete(`/api/events/${id}`, {
        params: scope ? { scope } : undefined
      })
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || '일정 삭제에 실패했습니다.')
      throw error
    }
  }
}
